import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

const selectOnboarding = (state: RootState) => state.onboarding;

export const selectInvitation = (state: RootState) => selectOnboarding(state).invitation;
export const selectInvitationStatus = (state: RootState) =>
  selectOnboarding(state).invitationStatus;
export const selectInvitationError = (state: RootState) => selectOnboarding(state).invitationError;
export const selectDraft = (state: RootState) => selectOnboarding(state).draft;
export const selectStatus = (state: RootState) => selectOnboarding(state).status;
export const selectError = (state: RootState) => selectOnboarding(state).error;
export const selectValidationErrors = (state: RootState) =>
  selectOnboarding(state).validationErrors;
export const selectIsSubmitting = (state: RootState) =>
  selectOnboarding(state).status === 'submitting';
/** Has the account been set up? Drives the success view + redirect to login. */
export const selectHasSucceeded = (state: RootState) =>
  selectOnboarding(state).status === 'succeeded';

/**
 * Derived: can the form be submitted? Deliberately non-emptiness only (the
 * original page's `disabled={!password || !confirmPassword}`); the min-length
 * and match rules fire at submit time in the saga, like the original early
 * returns. Memoised on the draft reference.
 */
export const selectCanSubmit = createSelector(
  selectDraft,
  (draft) => draft.password !== '' && draft.confirmPassword !== '',
);
